import { useRef, useState } from 'react'
import { Box, ButtonBase, Popover } from '@mui/material'
import Sketch from '@uiw/react-color-sketch'

interface Props {
  value: string
  onChange: (hex: string) => void
  'aria-label'?: string
}

export function ColorPicker({ value, onChange, 'aria-label': ariaLabel }: Props) {
  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  return (
    <>
      <ButtonBase
        ref={triggerRef}
        onClick={() => setAnchorEl(triggerRef.current)}
        aria-label={ariaLabel}
        sx={{
          p: '5px',
          bgcolor: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
          cursor: 'pointer',
        }}
      >
        <Box
          data-testid="color-swatch"
          sx={{
            width: 36,
            height: 14,
            borderRadius: '2px',
            bgcolor: value,
          }}
        />
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Sketch color={value} onChange={(c) => onChange(c.hex)} disableAlpha />
      </Popover>
    </>
  )
}
